<template>
  <section class="section signin">
    <h1 class="title has-text-centered" id="signin-title">Logg inn</h1>


    <div class="column">

      <div class="card" id="login-card">
        <div class="card-whole">

          <div class="card-content">

            <!--    <button class="button" id="btn-login-fb" @click="signUpWithFacebook()">Logg inn med Facebook</button>

            <div class="button" id="btn-login-fb" @click="signInWithGoogle()">Logg inn med Google</div>


            <div class="columns">
            <div class="column">
            <hr>
          </div>
          <label class="label" id="divider-label">eller</label>
          <div class="column">
          <hr>
        </div>

      </div> -->

      <form v-on:submit.prevent>
        <div class="field">
          <label class="label">Epost</label>
          <p class="control">
            <input class="input signin-email" type="email" placeholder="" v-model="email">
          </p>
        </div>
        <div class="field">
          <label class="label">Passord</label>
          <p class="control">
            <input class="input signin-password" type="password" placeholder="" v-model="password">
          </p>
        </div>
        <button type="submit" class="button is-primary" v-on:click="signIn" id="btn-login">Logg inn</button>
        <br><br><a id="forgot-pass" @click="sendForgotPassword">Glemt passord?</a>
        <br>
      </form>
    </div>
  </div>
</div>
</div>

</section>
</template>

<script>
import Firebase from "firebase";

export default {
  data: function() {
    return {
      email: '',
      password: '',

      invalidEmail: false,
      wrongPassword: false,
      userNotFound: false,

      forgotPasswordEmail: '',
    };
  },
  methods: {
    signIn: function() {
      Firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
        user => {
          var userRef = Firebase.database().ref('users/'+user.uid+'/hasPaid').on('value', snapshot => {
            console.log(snapshot.val());
            if(snapshot.val()) {this.$router.replace('user')}
            else {window.location.replace('https://combine.no'+'/order/')};
          });
          //this.$router.replace('user');
        },
        error => {
          alert(error.message);
          if(error.code === "auth/invalid-email") {this.invalidEmail = true}
          else if(error.code === "auth/wrong-password") {this.wrongPassword = true}
          else if(error.code === "auth/user-not-found") {this.userNotFound = true}
        }
      );
    },
    signInWithGoogle: function() {
      var provider = new Firebase.auth.GoogleAuthProvider();

      Firebase.auth().signInWithPopup(provider).then(function(result) {
        // This gives you a Google Access Token. You can use it to access the Google API.
        var token = result.credential.accessToken;
        // The signed-in user info.
        var user = result.user;

        Firebase.database().ref('users/' + userID).set({
          firstName: fn,
          lastName: ln,
          email: em,
          tnr: tnr,
        });

        this.$router.replace('user');
        // ...
      }).catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // The email of the user's account used.
        var email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        var credential = error.credential;
        // ...
      });

    },
    signUpWithFacebook: function(){


      var provider = new Firebase.auth.FacebookAuthProvider();


      Firebase.auth().signInWithPopup(provider).then(function(result) {
        // This gives you a Facebook Access Token. You can use it to access the Facebook API.
        var token = result.credential.accessToken;
        // The signed-in user info.
        var user = result.user;

        // ...
      }).catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // The email of the user's account used.
        var email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        var credential = error.credential;
        // ...
      });

      Firebase.auth().getRedirectResult().then(function(result) {
        if (result.credential) {
          // This gives you a Facebook Access Token. You can use it to access the Facebook API.
          var token = result.credential.accessToken;
          // ...
        }
        // The signed-in user info.
        var user = result.user;

      }).catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // The email of the user's account used.
        var email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        var credential = error.credential;
        // ...
      });


    },
    sendForgotPassword: function(){
      var auth = Firebase.auth();
      var emailAddress = this.forgotPasswordEmail;

      auth.sendPasswordResetEmail(emailAddress).then(function() {
        // Email sent.
      }).catch(function(error) {
        // An error happened.
      });
    },
  }
};
</script>

<style lang="scss">

@media screen and (max-width: 768px) {

  #btn-login{
    background-color: #33335D;
    width: 255px;
  }
  .section.signin{
    padding-top: 110px;
    background-color: #F5F7F9;
    height: 1000px;
  }
}


@media screen and (min-width: 768px) {
.section.signin{
  padding-top: 110px;
  background-color: #F5F7F9;
  height: 1000px;
}

div.card#login-card {
  margin-left: auto;
  margin-right: auto;
  max-width: 350px;
  box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.0);
  transition: all 0.5s
}

.signin-email{

}

.signin-password{

}


#btn-login{
  background-color: #33335D;
  width: 300px;
}

#btn-login:hover{
  background-color: #514FAB;
  transform: translateY(-1px);
  transition: 0.2s;
}

#signin-title {
  font-family: 'Monserrat', sans-serif;
  font-weight: 400;
  font-size: 24px;
  font-weight: 800;
}

.label {
  font-size: 14px;
  font-family: 'Monserrat', sans-serif;
}

#btn-login{
  font-family: 'Monserrat', sans-serif;
  font-weight: 600;
}

#divider-label {
  margin-top: 25px;
}

#btn-login-fb {
  width: 300px;
  border-radius: 0px;
  background-color: #385794;
  color: white;
}
#forgot-pass{
  font-size: 14px;
  color: #3a3a3a;
}
}

</style>



// WEBPACK FOOTER //
// src/components/SignIn.vue